import React, { useState } from "react";
import Card from "components/card";
import { 
    Sparkles, User,
    Gift, MessageCircle,
} from "lucide-react";
import RecipientGrid from "./RecipientGrid";
import TextArea from "antd/es/input/TextArea";
import Button from "components/button";

const GiftVoucher = ({ onClose, cartItems = [] }) => {
    const [selectedRecipient, setSelectedRecipient] = useState(null);

    const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
    const totalPoints = cartItems.reduce((sum, item) => sum + item.voucher.points * item.quantity, 0);

    const handleCompleteGift = () => {
        if (!selectedRecipient) return;
        console.log("Gifting", cartItems, "to", selectedRecipient);
        onClose();
    };

    return (
        <Card className="bg-white gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg max-w-3xl flex flex-col">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <h2 className="text-lg leading-none font-semibold flex items-center gap-2">
                    <Gift className="w-5 h-5" />
                    Gift Vouchers - Select Recipient
                </h2>
                <p className="text-slate-700 text-sm">
                    Choose an employee to gift these vouchers to
                </p>
            </div>
            <div className="space-y-4">
                <div className="text-slate-900 flex flex-col gap-6 rounded-xl bg-gradient-to-r from-emerald-50 to-purple-50 border-2 border-emerald-200">
                    <div className="pb-6 p-4">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-[12px] text-slate-700">
                                    Total Items
                                </p>
                                <p className="font-bold">
                                    {totalItems} {totalItems === 1 ? "voucher" : "vouchers"}
                                </p>
                            </div>
                            <div className="text-right">
                                <p className="text-[12px] text-slate-700">
                                    Total Points
                                </p>
                                <p className="font-bold text-emerald-600 flex items-center gap-1">
                                    <Sparkles className="w-4 h-4" />
                                    {totalPoints}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="space-y-3">
                    <div className="flex items-center gap-2">
                        <User className="lucide lucide-user w-5 h-5 text-emerald-600" />
                        <h3 className="font-medium">
                            Select Recipient
                        </h3>
                    </div>
                    <RecipientGrid 
                        selectedRecipient={selectedRecipient} 
                        setSelectedRecipient={setSelectedRecipient}
                    />
                </div>
                <div className="space-y-3">
                    <div className="flex items-center gap-2">
                        <MessageCircle className="w-5 h-5 text-purple-600" />
                        <h3 className="font-medium">
                            Gift Message (Optional)
                        </h3>
                    </div>
                    <TextArea
                        className="input-field"
						maxLength={255}
                        placeholder="Add a personalized message for the recipient..."
                        rows={2}
                    />
                </div>
                <div className="flex gap-3 pt-2">
                    <Button
                        onClick={onClose}
                        className="flex-1 h-8 border rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center hover:shadow-none hover:bg-slate-100"
                    >
                        Back to Cart
                    </Button>

                    <Button
                        disabled={!selectedRecipient}
                        onClick={handleCompleteGift}
                        className={`inline-flex items-center justify-center whitespace-nowrap text-sm font-medium outline-none h-8 rounded-md gap-1.5 px-3 flex-1 
                            bg-gradient-to-r from-emerald-600 to-purple-600 text-white
                            ${!selectedRecipient ? "opacity-50 cursor-not-allowed" : ""}`
    }
                    >
                        <Gift className="w-4 h-4 mr-1" />
                        Complte Gift
                    </Button>
                </div>
            </div>
        </Card>
    )
};
export default GiftVoucher;
